import type { NarrationLocales } from "./narrationLocaleContracts";

export function NarrationLocalesPanel({ value }: { value?: NarrationLocales }) {
  if (!value) return null;
  return (
    <section className="space-y-3 rounded-md border p-4">
      <h2 className="font-semibold">Spanish narration accents</h2>
      <p className="text-sm text-muted-foreground">
        Routing: {value.mode}. Country labels from the provider are candidates;
        native listening reviews qualify a voice. An owner-accepted route may
        ship before those reviews and is labeled unassessed. Each generated
        output still needs its own assessment.
      </p>
      <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {value.locales.map((row) => (
          <article className="rounded border p-3 text-sm" key={row.locale}>
            <p className="font-medium">
              {row.locale}: {row.status}
            </p>
            {row.voices.map((voice) => (
              <p className="text-xs text-muted-foreground" key={voice.voice_id}>
                {voice.voice_id} · {voice.model_id} · {voice.profile_id} ·{" "}
                {voice.status}
                {" · "}
                {voice.native_reviewer_count} native reviewers
              </p>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
}
